import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/sub.svg';
import _imports_1 from '@/assets/icon/add.svg';

const _withScopeId = n => (_pushScopeId("data-v-2e13dd87"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "collection-mint-container"
};
const _hoisted_2 = {
  class: "collection-mint-wrapper"
};
const _hoisted_3 = {
  class: "block"
};
const _hoisted_4 = {
  class: "wrapper"
};
const _hoisted_5 = {
  class: "image-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "block"
};
const _hoisted_8 = {
  class: "wrapper"
};
const _hoisted_9 = {
  class: "row title"
};
const _hoisted_10 = {
  class: "collection-name-wrapper"
};
const _hoisted_11 = {
  class: "font-subtitle1 name"
};
const _hoisted_12 = {
  class: "row"
};
const _hoisted_13 = {
  class: "font-body2 desc"
};
const _hoisted_14 = {
  class: "row mobile-hidden"
};
const _hoisted_15 = {
  class: "text-container"
};
const _hoisted_16 = {
  class: "calc-wrapper"
};
const _hoisted_17 = {
  class: "font-h6 text-wrapper"
};
const _hoisted_18 = {
  key: 0,
  class: "font-display7"
};
const _hoisted_19 = {
  class: "font-display7"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-arrow"
}, null, -1));

const _hoisted_21 = {
  class: "sale-detail-wrapper"
};
const _hoisted_22 = {
  class: "col"
};
const _hoisted_23 = {
  class: "row"
};
const _hoisted_24 = {
  class: "font-h6 value"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Mint Date")], -1));

const _hoisted_26 = {
  class: "col"
};
const _hoisted_27 = {
  class: "row"
};
const _hoisted_28 = {
  class: "font-h6 value"
};
const _hoisted_29 = {
  class: "font-subtitle2 unit"
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Price")], -1));

const _hoisted_31 = {
  class: "col"
};
const _hoisted_32 = {
  class: "row"
};
const _hoisted_33 = {
  class: "font-h6 value"
};

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle2 unit"
}, null, -1));

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1 title"
}, "Items")], -1));

const _hoisted_36 = {
  class: "row desktop-hidden"
};
const _hoisted_37 = {
  class: "text-container"
};
const _hoisted_38 = {
  class: "calc-wrapper"
};
const _hoisted_39 = {
  class: "font-h6 text-wrapper"
};
const _hoisted_40 = {
  class: "font-display7"
};

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-arrow"
}, null, -1));

const _hoisted_42 = {
  key: 0,
  class: "collection-banner-wrapper"
};
const _hoisted_43 = {
  class: "showcase-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_confirm_modal = _resolveComponent("confirm-modal");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.info.title === 'Capybara NFT' ? $setup.Blindbox : $setup.BlindboxAlliance,
    alt: "image"
  }, null, 8, _hoisted_6)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "profile-picture",
    style: _normalizeStyle(`background-image: url(${$data.info.profile})`)
  }, null, 4), _createElementVNode("h5", _hoisted_11, _toDisplayString(`${$data.info.title || "-"}`), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString($data.info.desc), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
    src: _imports_0,
    alt: "image",
    onClick: _cache[0] || (_cache[0] = $event => $options.changeAmount(-1))
  }), _createElementVNode("div", _hoisted_17, _toDisplayString(this.amount), 1), _createElementVNode("img", {
    src: _imports_1,
    alt: "image",
    onClick: _cache[1] || (_cache[1] = $event => $options.changeAmount(1))
  })]), _createElementVNode("button", {
    class: _normalizeClass(["btn apply", {
      disabled: $data.symbol === 'DEM' || !$options.isOpen || $data.mintLoading || $data.checking
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.openConfirm && $options.openConfirm(...args))
  }, [$data.symbol === 'DEM' ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString("Finished"))) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("span", _hoisted_19, _toDisplayString($data.checking ? "Checking..." : "Mint Now"), 1), _hoisted_20], 64))], 2)])])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("h6", _hoisted_24, _toDisplayString($options.date.date), 1)]), _hoisted_25]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("h6", _hoisted_28, _toDisplayString($data.info.price), 1), _createElementVNode("span", _hoisted_29, _toDisplayString($data.info.unit), 1)]), _hoisted_30]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("h6", _hoisted_33, _toDisplayString($data.info.item), 1), _hoisted_34]), _hoisted_35]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
    src: _imports_0,
    alt: "image",
    onClick: _cache[3] || (_cache[3] = $event => $options.changeAmount(-1))
  }), _createElementVNode("div", _hoisted_39, _toDisplayString(this.amount), 1), _createElementVNode("img", {
    src: _imports_1,
    alt: "image",
    onClick: _cache[4] || (_cache[4] = $event => $options.changeAmount(1))
  })]), _createElementVNode("button", {
    class: _normalizeClass(["btn apply", {
      disabled: !$options.isOpen || $data.mintLoading || $data.checking
    }]),
    onClick: _cache[5] || (_cache[5] = (...args) => $options.openConfirm && $options.openConfirm(...args))
  }, [_createElementVNode("span", _hoisted_40, _toDisplayString($data.checking ? "Checking..." : "Mint Now"), 1), _hoisted_41], 2)])])]), $data.info.title === 'Capybara NFT' ? (_openBlock(), _createElementBlock("div", _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showcase, item => {
    return _openBlock(), _createElementBlock("div", {
      key: `showcase-${item.name}`,
      style: _normalizeStyle(`background-image: url(${item.img})`),
      class: "image-wrapper"
    }, null, 4);
  }), 128))])]), $data.isToggle ? (_openBlock(), _createBlock(_component_confirm_modal, {
    key: 0,
    onConfirm: $options.mint
  }, null, 8, ["onConfirm"])) : _createCommentVNode("", true)], 64);
}